import type { Canvas, FabricObject } from 'fabric';

// Lookup a fabric object by its `id` custom property. Shared by the
// Fabric Query / Write sub-services so the id → object resolution
// stays a single source of truth.
function findFabricObjectById(canvas: Canvas, id: string): FabricObject | undefined {
    return canvas.getObjects().find((object) => (object as FabricObject & { id?: string }).id === id);
}

export { findFabricObjectById };
